import './App.scss';
import Header from './components/Header';
import Main from './components/Main';
import Section from './components/Section';
import Works from './components/Works';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Header/>
      <Main/>
      <Section/>
      <Works/>
      <Contact/>

    </div>
  );
}

export default App;